"use strict"

import React, { useEffect, useState } from "react"

import { updateObject } from "../../../Loaders"
import { logToServer } from "../../../ErrorBoundary"
import EditSingleFileModal from "../../../shared_components/administration/file_uploads/EditSingleFileModal"

export default function FileActionRow({ selections, tableReload, user_can_edit, intl }) {
  const [selectedFiles, setSelectedFiles] = useState([])
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    setSelectedFiles(selections)
  }, [])

  useEffect(() => {
    setSelectedFiles(selections)
  }, [selections])

  const downloadFiles = (e) => {
    e.preventDefault()
    window.location.href = "/lake/files/zip?file_id=" + selectedFiles.join(",")
  }

  const reprocessFiles = (e) => {
    e.preventDefault()
    updateObject(
      `/lake/files/bulkretransform/`,
      {
        file_id: selectedFiles.join(","),
      },
      false,
      false,
    )
      .then((_) => {
        alert(intl.formatMessage({ id: "administration.success-reprocess-selected-files" }))
        tableReload()
      })
      .catch((error) => {
        logToServer(`Couldn't retransform files: ${error}`)
        console.error(error)
        alert(`${intl.formatMessage({ id: "general.server.error" })}: ${error}`)
      })
  }

  const spacingStyle = { marginRight: "0.4em" }
  return (
    <>
      {user_can_edit && (
        <p className="file-action-row">
          {showModal && user_can_edit && (
            <EditSingleFileModal
              intl={intl}
              file_id={null}
              show={showModal}
              tableReload={tableReload}
              onHide={() => {
                setShowModal(false)
              }}
            />
          )}
          <a
            href="#"
            className={`selection-action${selectedFiles.length > 0 ? "" : " disabled"}`}
            style={spacingStyle}
            onClick={downloadFiles}
          >
            <span className="fa fa-cloud-download" style={spacingStyle} />
            {intl.formatMessage({ id: "administration.download-selected-files" })}
          </a>
          <span style={spacingStyle}>|</span>
          <a
            href="#"
            className={`selection-action${selectedFiles.length > 0 ? "" : " disabled"}`}
            style={spacingStyle}
            onClick={reprocessFiles}
          >
            <span className="fa fa-refresh" style={spacingStyle} />
            {intl.formatMessage({ id: "administration.reprocess-selected-files" })}
          </a>
          <span style={spacingStyle}>|</span>
          <a href="#" onClick={() => setShowModal(true)}>
            <span className="fa fa-plus-circle" style={spacingStyle} />
            {intl.formatMessage({ id: "administration.upload-file" })}
          </a>
        </p>
      )}
    </>
  )
}
